import { Box, Typography } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
interface VersionSwitchProps {
  onVersionChange?: (isV2: boolean) => void;
  defaultVersion?: 'v1' | 'v2';
  value?: boolean;
}
const VersionSwitch = ({
  onVersionChange,
  defaultVersion = 'v2',
  value,
}: VersionSwitchProps) => {
  const { t } = useTranslation();
  const [internalIsV2, setInternalIsV2] = useState(defaultVersion === 'v2');
  const isControlled = useMemo(() => typeof value === 'boolean', [value]);
  const isV2 = isControlled ? (value as boolean) : internalIsV2;

  useEffect(() => {
    if (isControlled) {
      setInternalIsV2(value as boolean);
      return;
    }
    setInternalIsV2(defaultVersion === 'v2');
  }, [defaultVersion, isControlled, value]);

  const handleToggle = () => {
    const newValue = !isV2;
    if (!isControlled) {
      setInternalIsV2(newValue);
    }
    onVersionChange?.(newValue);
  };
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
      <Typography variant="body2" sx={{ fontWeight: 500, color: '#5C677E' }}>
        {t('Action Version')}
      </Typography>
      <Box
        onClick={handleToggle}
        sx={{
          position: 'relative',
          width: 60,
          height: 30,
          borderRadius: 15,
          backgroundColor: isV2 ? '#1976D2' : '#ccc',
          cursor: 'pointer',
          transition: 'background-color 0.3s ease',
          '&:hover': {
            backgroundColor: isV2 ? '#1565C0' : '#bbb',
          },
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 2,
            left: isV2 ? 32 : 2,
            width: 26,
            height: 26,
            borderRadius: '50%',
            backgroundColor: 'white',
            transition: 'left 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            fontWeight: 'bold',
            color: isV2 ? '#1976D2' : '#666',
          }}
        >
          {isV2 ? 'v2' : 'v1'}
        </Box>
      </Box>
    </Box>
  );
};
export default VersionSwitch;
